import React, { useState } from 'react';


export const EV = ({ data, current_devices }) => {
    console.log("Current Devices:", current_devices);
    const [make, setMake] = useState("");
    const [model, setModel] = useState("");
    const [year, setYear] = useState("");
    const [selectedEV, setSelectedEV] = useState({});

    const vehicles = data.filter(item => item.asset_type === "vehicle");
    const makes = [...new Set(vehicles.map(item => item.make))];

    const filteredByMake = vehicles.filter(item => item.make === make);
    const models = [...new Set(filteredByMake.map(item => item.model))];

    const filteredByModel = filteredByMake.filter(item => item.model === model);
    const years = [...new Set(filteredByModel.map(item => item.year))];

    const handleYearChange = (e) => {
        const selectedYear = e.target.value;
        setYear(selectedYear);
        const match = vehicles.find(car => car.year === parseInt(selectedYear) && car.make === make && car.model === model);
        console.log("Matching Vehicle:", match);
        if (match) {
            setSelectedEV(match);
        }
        console.log("Selected EV:", selectedEV);
    };

    return (
        <div>
            <section>
                <div className="inner">
                    <div className="wizard-header">
                        <h3 className="heading">Electric Vehicle</h3>
                        <p>Select a vehicle from the dropdown below.</p>
                    </div>

                    {/* Make Dropdown */}
                    <div className="form-row">
                        <div className="form-holder">
                            <legend>Select Your Make</legend>
                            <select
                                name="ev_vehicle_make"
                                value={make}
                                onChange={(e) => {
                                    setMake(e.target.value);
                                    setModel("");
                                    setYear("");
                                    setSelectedEV(null);
                                }}
                            >
                                <option value="" disabled selected>Select a Make</option>
                                {makes.sort((a, b) => a.localeCompare(b)).map((makeOption) => (
                                    <option key={makeOption} value={makeOption}>
                                        {makeOption}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Model Dropdown */}
                    {make && (
                        <div className="form-row">
                            <div className="form-holder">
                                <legend>Select Your Model</legend>
                                <select
                                    name="ev_vehicle_model"
                                    value={model}
                                    onChange={(e) => {
                                        setModel(e.target.value);
                                        setYear("");
                                        setSelectedEV(null);
                                    }}
                                >
                                    <option value="" disabled selected>Select a Model</option>
                                    {models.sort((a, b) => a.localeCompare(b)).map((modelOption) => (
                                        <option key={modelOption} value={modelOption}>
                                            {modelOption}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}

                    {/* Year Dropdown */}
                    {model && (
                        <div className="form-row">
                            <div className="form-holder">
                                <legend>Select Year</legend>
                                <select
                                    name="ev_vehicle_year"
                                    value={year}
                                    onChange={(e) => handleYearChange(e)}
                                >
                                    <option value="" disabled selected>Select a Year</option>
                                    {years.sort((a, b) => a - b).map((yearOption) => (
                                        <option key={yearOption} value={yearOption}>
                                            {yearOption}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}
                    <div className="form-row">
                        <div className="form-holder">
                            {current_devices.length > 0 ? (<h4>Current Electric Vehicles</h4>) : (<div></div>)}
                            {current_devices.length > 0 ? (
                                <div style={{
                                    padding: '10px',
                                    borderRadius: '4px',
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                    gap: '10px'
                                }}>
                                    {current_devices.sort((a, b) => a.make.localeCompare(b.make)).map((device, index) => (
                                        <div key={index} style={{
                                            backgroundColor: '#f0f0f0',
                                            border: '1px solid #ccc', padding: '10px', borderRadius: '4px'
                                        }}>
                                            {device.make} {device.model} ({device.year})
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div></div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};


export const Battery = ({ data, current_devices }) => {
    const batteries = data.filter(item => item.asset_type === 'battery');
    const [batteryMake, setBatteryMake] = useState("");
    const [batteryModel, setBatteryModel] = useState("");
    const [selectedBattery, setSelectedBattery] = useState({});

    const makes = [...new Set(batteries.map(item => item.make))];
    const filteredByMake = batteries.filter(item => item.make === batteryMake);
    const models = [...new Set(filteredByMake.map(item => item.model))];
    const filteredByModel = filteredByMake.filter(item => item.model === batteryModel);
    const years = [...new Set(filteredByModel.map(item => item.year))];



    return (
        <div>
            <section>
                <div className="inner">
                    <div className="wizard-header">
                        <h3 className="heading">Battery Storage</h3>
                        <p>Select your battery storage system from the dropdown below.</p>
                    </div>
                    {/* Battery Make Dropdown */}
                    <div className="form-row">
                        <div className="form-holder">
                            <legend>Select Your Battery Make</legend>
                            <select
                                name="battery_make"
                                value={batteryMake}
                                onChange={(e) => {
                                    setBatteryMake(e.target.value);
                                    setBatteryModel("");
                                    setSelectedBattery({});
                                }}
                            >
                                <option value="" disabled selected>Select a Make</option>
                                {makes.sort((a, b) => a.localeCompare(b)).map(makeOption => (
                                    <option key={makeOption} value={makeOption}>
                                        {makeOption}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {/* Battery Model Dropdown */}
                    {batteryMake && (
                        <div className="form-row">
                            <div className="form-holder">
                                <legend>Select Your Battery Model</legend>
                                <select
                                    name="battery_model"
                                    value={batteryModel}
                                    onChange={(e) => {
                                        setBatteryModel(e.target.value);
                                        setSelectedBattery({});
                                    }}
                                >
                                    <option value="" disabled selected>Select a Model</option>
                                    {models.sort((a, b) => a.localeCompare(b)).map(modelOption => (
                                        <option key={modelOption} value={modelOption}>
                                            {modelOption}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}
                    {/* Render current battery devices */}
                    <div className="form-row">
                        <div className="form-holder">
                            {current_devices && current_devices.length > 0 ? (<h4>Current Battery Storage Systems</h4>) : (<div></div>)}
                            {current_devices && current_devices.length > 0 ? (
                                <div style={{
                                    padding: '10px',
                                    borderRadius: '4px',
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                    gap: '10px'
                                }}>
                                    {current_devices.sort((a, b) => a.make.localeCompare(b.make)).map((device, index) => (
                                        <div key={index} style={{
                                            backgroundColor: '#f0f0f0',
                                            border: '1px solid #ccc',
                                            padding: '10px',
                                            borderRadius: '4px'
                                        }}>
                                            {device.make} {device.model} ({device.year})
                                        </div>
                                    ))}
                                </div>
                            ) : (<div></div>)}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export const Inverter = ({ data, current_devices }) => {
    // Filter inverter assets
    const inverters = data.filter(item => item.asset_type === 'inverter');
    // New states for make and model selection
    const [inverterMake, setInverterMake] = useState("");
    const [inverterModel, setInverterModel] = useState("");
    const [selectedInverter, setSelectedInverter] = useState(null);

    // Get unique makes and filter to get models for selected make
    const makes = [...new Set(inverters.map(item => item.make))];
    const filteredByMake = inverters.filter(item => item.make === inverterMake);
    const models = [...new Set(filteredByMake.map(item => item.model))];

    return (
        <div>
            <section>
                <div className="inner">
                    <div className="wizard-header">
                        <h3 className="heading">Solar Inverter</h3>
                        <p>Select your solar inverter by first choosing the make and then the model.</p>
                    </div>
                    {/* Inverter Make Dropdown */}
                    <div className="form-row">
                        <div className="form-holder">
                            <legend>Select Your Inverter Make</legend>
                            <select
                                name="inverter_make"
                                value={inverterMake}
                                onChange={(e) => {
                                    setInverterMake(e.target.value);
                                    setInverterModel("");
                                    setSelectedInverter(null);
                                }}
                            >
                                <option value="" disabled selected>Select a Make</option>
                                {makes.sort((a, b) => a.localeCompare(b)).map(makeOption => (
                                    <option key={makeOption} value={makeOption}>
                                        {makeOption}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {/* Inverter Model Dropdown */}
                    {inverterMake && (
                        <div className="form-row">
                            <div className="form-holder">
                                <legend>Select Your Inverter Model</legend>
                                <select
                                    name="inverter_model"
                                    value={inverterModel}
                                    onChange={(e) => {
                                        setInverterModel(e.target.value);
                                        // Optionally, find and store the matching inverter object
                                        const match = filteredByMake.find(inv => inv.model === e.target.value);
                                        if (match) {
                                            setSelectedInverter(match);
                                        }
                                    }}
                                >
                                    <option value="" disabled selected>Select a Model</option>
                                    {models.sort((a, b) => a.localeCompare(b)).map(modelOption => (
                                        <option key={modelOption} value={modelOption}>
                                            {modelOption}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}
                    {/* Render current inverter devices */}
                    <div className="form-row">
                        <div className="form-holder">
                            {current_devices && current_devices.length > 0 ? (<h4>Current Solar Inverters</h4>) : (<div></div>)}
                            {current_devices && current_devices.length > 0 ? (
                                <div style={{
                                    padding: '10px',
                                    borderRadius: '4px',
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                    gap: '10px'
                                }}>
                                    {current_devices.sort((a, b) => a.make.localeCompare(b.make)).map((device, index) => (
                                        <div key={index} style={{
                                            backgroundColor: '#f0f0f0',
                                            border: '1px solid #ccc',
                                            padding: '10px',
                                            borderRadius: '4px'
                                        }}>
                                            {device.make} {device.model} ({device.year})
                                        </div>
                                    ))}
                                </div>
                            ) : (<div></div>)}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export const PersonalInformation = ({ data }) => {
    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});
    const [utility, setOther] = useState(false)
    const [utility_selected, setUtilityTariffOptions] = useState([])

    // Validation functions for each field
    const validate = (name, value) => {
        switch (name) {
            case "first-name":
                if (!value) return "First name is required.";
                if (value.length < 2) return "First name must be at least 2 characters.";
                if (!/^[A-Za-z\s\-']+$/.test(value)) return "First name should only contain letters, spaces, hyphens, or apostrophes.";
                break;
            case "last-name":
                if (!value) return "Last name is required.";
                if (value.length < 2) return "Last name must be at least 2 characters.";
                if (!/^[A-Za-z\s\-']+$/.test(value)) return "Last name should only contain letters, spaces, hyphens, or apostrophes.";
                break;
            case "your_email":
                if (!value) return "Email is required.";
                if (!/^[^@]+@[^@]+\.[a-zA-Z]{2,6}$/.test(value)) return "Please enter a valid email address.";
                break;
            case "phone":
                if (!value) return "Phone number is required.";
                if (!/^\+?1?\s?(\d{3}[-\s]?){2}\d{4}$/.test(value)) return "Please enter a valid US phone number.";
                break;
            case "address-line1":
                if (!value) return "Address Line 1 is required.";
                if (value.length < 3) return "Address Line 1 must be at least 3 characters.";
                break;
            case "city":
                if (!value) return "City is required.";
                if (value.length < 2) return "City must be at least 2 characters.";
                if (!/^[A-Za-z\s\-']+$/.test(value)) return "City should only contain letters, spaces, hyphens, or apostrophes.";
                break;
            case "state":
                if (!value) return "State is required.";
                break;
            case "postal-code":
                if (!value) return "Postal code is required.";
                if (!/^\d{5}(-\d{4})?$/.test(value)) return "Please enter a valid US ZIP code.";
                break;
            case "utility":
                if (!value) return "Utility is required.";
                break;
            default:
                return "";
        }
        return "";
    };

    // Store field values in state
    const [fields, setFields] = useState({
        "first-name": "",
        "last-name": "",
        "your_email": "",
        "phone": "",
        "address-line1": "",
        "address-line2": "",
        "city": "",
        "state": "",
        "postal-code": "",
        "utility": ""
    });

    const handleBlur = (e) => {
        const { name, value } = e.target;
        setTouched(prev => ({ ...prev, [name]: true }));
        setErrors(prev => ({ ...prev, [name]: validate(name, value) }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields(prev => ({ ...prev, [name]: value }));
        if (touched[name]) {
            setErrors(prev => ({ ...prev, [name]: validate(name, value) }));
        }
    };

    const errorStyle = { borderColor: 'red' };
    const errorMsgStyle = { color: 'red', fontSize: '0.9em', marginTop: 2 };

    return (
        <div>
            <section>
                <div className="inner">
                    <div className="wizard-header">
                        <h3 className="heading">Personal Information</h3>
                        <p>Please enter your information and proceed to the next step so we can build your account.</p>
                    </div>
                    <div className="form-row">
                        <div className="form-holder">
                            <fieldset>
                                <legend>First Name</legend>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="first-name"
                                    name="first-name"
                                    placeholder="First Name"
                                    required
                                    minLength={2}
                                    maxLength={50}
                                    pattern="^[A-Za-z\s\-']+$"
                                    title="First name should only contain letters, spaces, hyphens, or apostrophes."
                                    value={fields["first-name"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["first-name"] && touched["first-name"] ? errorStyle : undefined}
                                />
                                {errors["first-name"] && touched["first-name"] && (
                                    <div style={errorMsgStyle}>{errors["first-name"]}</div>
                                )}
                            </fieldset>
                        </div>
                        <div className="form-holder">
                            <fieldset>
                                <legend>Last Name</legend>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="last-name"
                                    name="last-name"
                                    placeholder="Last Name"
                                    required
                                    minLength={2}
                                    maxLength={50}
                                    pattern="^[A-Za-z\s\-']+$"
                                    title="Last name should only contain letters, spaces, hyphens, or apostrophes."
                                    value={fields["last-name"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["last-name"] && touched["last-name"] ? errorStyle : undefined}
                                />
                                {errors["last-name"] && touched["last-name"] && (
                                    <div style={errorMsgStyle}>{errors["last-name"]}</div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder form-holder-2">
                            <fieldset>
                                <legend>Your Email</legend>
                                <input
                                    type="email"
                                    name="your_email"
                                    id="your_email"
                                    className="form-control"
                                    pattern="^[^@]+@[^@]+\.[a-zA-Z]{2,6}$"
                                    placeholder="example@email.com"
                                    required
                                    maxLength={100}
                                    title="Please enter a valid email address."
                                    value={fields["your_email"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["your_email"] && touched["your_email"] ? errorStyle : undefined}
                                />
                                {errors["your_email"] && touched["your_email"] && (
                                    <div style={errorMsgStyle}>{errors["your_email"]}</div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder form-holder-2">
                            <fieldset>
                                <legend>Phone Number</legend>
                                <input
                                    type="tel"
                                    className="form-control"
                                    id="phone"
                                    name="phone"
                                    placeholder="+1 888-999-7777"
                                    required
                                    pattern="^\+?1?\s?(\d{3}[-\s]?){2}\d{4}$"
                                    maxLength={20}
                                    title="Please enter a valid US phone number."
                                    value={fields["phone"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["phone"] && touched["phone"] ? errorStyle : undefined}
                                />
                                {errors["phone"] && touched["phone"] && (
                                    <div style={errorMsgStyle}>{errors["phone"]}</div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder form-holder-2">
                            <fieldset>
                                <legend>Address Line 1</legend>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="address-line1"
                                    name="address-line1"
                                    placeholder="Street Address"
                                    required
                                    minLength={3}
                                    maxLength={100}
                                    value={fields["address-line1"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["address-line1"] && touched["address-line1"] ? errorStyle : undefined}
                                />
                                {errors["address-line1"] && touched["address-line1"] && (
                                    <div style={errorMsgStyle}>{errors["address-line1"]}</div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder form-holder-2">
                            <fieldset>
                                <legend>Address Line 2</legend>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="address-line2"
                                    name="address-line2"
                                    placeholder="Apartment, Suite, etc. (optional)"
                                    maxLength={100}
                                    value={fields["address-line2"]}
                                    onChange={handleChange}
                                />
                            </fieldset>
                        </div>
                    </div>
                    {/* Add City Field */}
                    <div className="form-row">
                        <div className="form-holder form-holder-2">
                            <fieldset>
                                <legend>City</legend>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="city"
                                    name="city"
                                    placeholder="City"
                                    required
                                    minLength={2}
                                    maxLength={50}
                                    pattern="^[A-Za-z\s\-']+$"
                                    title="City should only contain letters, spaces, hyphens, or apostrophes."
                                    value={fields["city"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["city"] && touched["city"] ? errorStyle : undefined}
                                />
                                {errors["city"] && touched["city"] && (
                                    <div style={errorMsgStyle}>{errors["city"]}</div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder">

                            <fieldset>
                                <legend>State</legend>
                                <select
                                    id="state"
                                    name="state"
                                    required
                                    value={fields["state"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={{
                                        ...(errors["state"] && touched["state"] ? errorStyle : {}),
                                        border: 'none'
                                    }}
                                >
                                    <option value="" disabled hidden>Select State</option>
                                    <option value="AL">Alabama</option>
                                    <option value="AK">Alaska</option>
                                    <option value="AZ">Arizona</option>
                                    <option value="AR">Arkansas</option>
                                    <option value="CA">California</option>
                                    <option value="CO">Colorado</option>
                                    <option value="CT">Connecticut</option>
                                    <option value="DE">Delaware</option>
                                    <option value="FL">Florida</option>
                                    <option value="GA">Georgia</option>
                                    <option value="HI">Hawaii</option>
                                    <option value="ID">Idaho</option>
                                    <option value="IL">Illinois</option>
                                    <option value="IN">Indiana</option>
                                    <option value="IA">Iowa</option>
                                    <option value="KS">Kansas</option>
                                    <option value="KY">Kentucky</option>
                                    <option value="LA">Louisiana</option>
                                    <option value="ME">Maine</option>
                                    <option value="MD">Maryland</option>
                                    <option value="MA">Massachusetts</option>
                                    <option value="MI">Michigan</option>
                                    <option value="MN">Minnesota</option>
                                    <option value="MS">Mississippi</option>
                                    <option value="MO">Missouri</option>
                                    <option value="MT">Montana</option>
                                    <option value="NE">Nebraska</option>
                                    <option value="NV">Nevada</option>
                                    <option value="NH">New Hampshire</option>
                                    <option value="NJ">New Jersey</option>
                                    <option value="NM">New Mexico</option>
                                    <option value="NY">New York</option>
                                    <option value="NC">North Carolina</option>
                                    <option value="ND">North Dakota</option>
                                    <option value="OH">Ohio</option>
                                    <option value="OK">Oklahoma</option>
                                    <option value="OR">Oregon</option>
                                    <option value="PA">Pennsylvania</option>
                                    <option value="RI">Rhode Island</option>
                                    <option value="SC">South Carolina</option>
                                    <option value="SD">South Dakota</option>
                                    <option value="TN">Tennessee</option>
                                    <option value="TX">Texas</option>
                                    <option value="UT">Utah</option>
                                    <option value="VT">Vermont</option>
                                    <option value="VA">Virginia</option>
                                    <option value="WA">Washington</option>
                                    <option value="WV">West Virginia</option>
                                    <option value="WI">Wisconsin</option>
                                    <option value="WY">Wyoming</option>
                                </select>
                                {errors["state"] && touched["state"] && (
                                    <div style={errorMsgStyle}>{errors["state"]}</div>
                                )}
                            </fieldset>
                        </div>
                        <div className="form-holder">
                            <fieldset>
                                <legend>Postal Code</legend>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="postal-code"
                                    name="postal-code"
                                    placeholder="Postal Code"
                                    required
                                    pattern="^\d{5}(-\d{4})?$"
                                    maxLength={10}
                                    title="Please enter a valid US ZIP code."
                                    value={fields["postal-code"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["postal-code"] && touched["postal-code"] ? errorStyle : undefined}
                                />
                                {errors["postal-code"] && touched["postal-code"] && (
                                    <div style={errorMsgStyle}>{errors["postal-code"]}</div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder form-holder-2">
                            <fieldset>
                                <legend>Utility</legend>
                                <select
                                    id="utility"
                                    name="utility"
                                    required
                                    value={fields["utility"]}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFields(prev => ({ ...prev, utility: value }));
                                        setOther(value === "other");
                                        if (value === "") {
                                            setUtilityTariffOptions([]);
                                        }
                                        else if (value === "other") {
                                            setUtilityTariffOptions([]);
                                        }
                                        else if (value in data.tariff_rate_mapper) {
                                            setUtilityTariffOptions(data.tariff_rate_mapper[value]);
                                        }
                                    }}

                                    onBlur={handleBlur}
                                    style={{
                                        ...(errors["utility"] && touched["utility"] ? errorStyle : {}),
                                        border: 'none'
                                    }}
                                >
                                    <option value="" disabled hidden>Select Utility</option>
                                    <option value="other">Other</option>
                                    {data.utilities && data.utilities.sort((a, b) => a.localeCompare(b)).map(utility => (
                                        <option key={utility} value={utility}>{utility}</option>
                                    ))}
                                </select>
                                {errors["utility"] && touched["utility"] && (
                                    <div style={errorMsgStyle}>{errors["utility"]}</div>
                                )}
                                {utility && (
                                    <div className="form-row">
                                        <div className="form-holder form-holder-2">
                                            <fieldset>
                                                <legend>Specify Utility</legend>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="other-utility"
                                                    name="other-utility"
                                                    placeholder="Enter your utility"
                                                    value={fields["other-utility"] || ""}
                                                    onChange={(e) => setFields(prev => ({ ...prev, "other-utility": e.target.value }))}
                                                />
                                            </fieldset>
                                        </div>
                                    </div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                    {/* Utility Tariff Rate Section */}
                    {fields["utility"] && fields["utility"] !== "other" ? (
                        <div className="form-row">
                            <div className="form-holder form-holder-2">
                                <fieldset>
                                    <legend>Utility Tariff Rate</legend>
                                    <select
                                        id="utility_rate"
                                        name="utility_rate"
                                        required
                                        value={fields["utility_rate"]}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFields(prev => ({ ...prev, utility_rate: value }));
                                        }}
                                        onBlur={handleBlur}
                                        style={{
                                            ...(errors["utility"] && touched["utility"] ? errorStyle : {}),
                                            border: 'none'
                                        }}
                                    >
                                        <option value="" disabled hidden selected>Select Available Tariff</option>
                                        <option value="other">Other</option>
                                        {utility_selected && utility_selected.sort((a, b) => a.localeCompare(b)).map(u => (
                                            <option key={u} value={u}>{u}</option>
                                        ))}
                                    </select>
                                </fieldset>
                            </div>
                        </div>
                    ) : (
                        <div className="form-row">
                            <div className="form-holder form-holder-2">
                                <fieldset>
                                    <legend>Specify Utility Tariff Rate</legend>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="utility_rate"
                                        name="utility_rate"
                                        placeholder="Enter tariff rate"
                                        value={fields["utility_rate"] || ""}
                                        onChange={(e) => setFields(prev => ({ ...prev, utility_rate: e.target.value }))}
                                    />
                                </fieldset>
                            </div>
                        </div>
                    )}
                    {fields["utility"] && fields["utility"] !== "other" && fields["utility_rate"] === "other" && (
                        <div className="form-row">
                            <div className="form-holder form-holder-2">
                                <fieldset>
                                    <legend>Specify Utility Tariff Rate</legend>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="other-utility_rate"
                                        name="other-utility_rate"
                                        placeholder="Enter tariff rate"
                                        value={fields["other-utility_rate"] || ""}
                                        onChange={(e) =>
                                            setFields(prev => ({ ...prev, "other-utility_rate": e.target.value }))
                                        }
                                    />
                                </fieldset>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export const Charger = ({ data, current_devices }) => {
    // Filter charger assets
    const chargers = data.filter(item => item.asset_type === 'charger');
    // New states for make and model selection
    const [chargerMake, setChargerMake] = useState("");
    const [chargerModel, setChargerModel] = useState("");
    const [selectedCharger, setSelectedCharger] = useState(null);

    // Get unique makes and models based on the selected make
    const makes = [...new Set(chargers.map(item => item.make))];
    const filteredByMake = chargers.filter(item => item.make === chargerMake);
    const models = [...new Set(filteredByMake.map(item => item.model))];

    return (
        <div>
            <section>
                <div className="inner">
                    <div className="wizard-header">
                        <h3 className="heading">Charger</h3>
                        <p>Select your ev charger by first choosing the make and then the model.</p>
                    </div>
                    {/* Charger Make Dropdown */}
                    <div className="form-row">
                        <div className="form-holder">
                            <legend>Select Your Charger Make</legend>
                            <select
                                name="charger_make"
                                value={chargerMake}
                                onChange={(e) => {
                                    setChargerMake(e.target.value);
                                    setChargerModel("");
                                    setSelectedCharger(null);
                                }}
                            >
                                <option value="" disabled selected>Select a Make</option>
                                {makes.sort((a, b) => a.localeCompare(b)).map(makeOption => (
                                    <option key={makeOption} value={makeOption}>
                                        {makeOption}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {/* Charger Model Dropdown */}
                    {chargerMake && (
                        <div className="form-row">
                            <div className="form-holder">
                                <legend>Select Your Charger Model</legend>
                                <select
                                    name="charger_model"
                                    value={chargerModel}
                                    onChange={(e) => {
                                        setChargerModel(e.target.value);
                                        const match = filteredByMake.find(ch => ch.model === e.target.value);
                                        if (match) {
                                            setSelectedCharger(match);
                                        }
                                    }}
                                >
                                    <option value="" disabled selected>Select a Model</option>
                                    {models.sort((a, b) => a.localeCompare(b)).map(modelOption => (
                                        <option key={modelOption} value={modelOption}>
                                            {modelOption}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}
                    {/* Render current charger devices */}
                    <div className="form-row">
                        <div className="form-holder">
                            {current_devices && current_devices.length > 0 ? (<h4>Current Chargers</h4>) : (<div></div>)}
                            {current_devices && current_devices.length > 0 ? (
                                <div style={{
                                    padding: '10px',
                                    borderRadius: '4px',
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                    gap: '10px'
                                }}>
                                    {current_devices.sort((a, b) => a.make.localeCompare(b.make)).map((device, index) => (
                                        <div key={index} style={{
                                            backgroundColor: '#f0f0f0',
                                            border: '1px solid #ccc',
                                            padding: '10px',
                                            borderRadius: '4px'
                                        }}>
                                            {device.make} {device.model} ({device.year})
                                        </div>
                                    ))}
                                </div>
                            ) : (<div></div>)}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export const Thermostat = ({ data, current_devices }) => {
    const thermostats = data.filter(item => item.asset_type === 'hvac');
    // New states for make, model, and selected thermostat
    const [thermostatMake, setThermostatMake] = useState("");
    const [thermostatModel, setThermostatModel] = useState("");
    const [selectedThermostat, setSelectedThermostat] = useState(null);

    // Get unique makes and models based on selected make
    const makes = [...new Set(thermostats.map(item => item.make))];
    const filteredByMake = thermostats.filter(item => item.make === thermostatMake);
    const models = [...new Set(filteredByMake.map(item => item.model))];

    return (
        <div>
            <section>
                <div className="inner">
                    <div className="wizard-header">
                        <h3 className="heading">Thermostat</h3>
                        <p>Select your thermostat by first choosing the make and then the model.</p>
                    </div>
                    {/* Thermostat Make Dropdown */}
                    <div className="form-row">
                        <div className="form-holder">
                            <legend>Select Your Thermostat Make</legend>
                            <select
                                name="thermostat_make"
                                value={thermostatMake}
                                onChange={(e) => {
                                    setThermostatMake(e.target.value);
                                    setThermostatModel("");
                                    setSelectedThermostat(null);
                                }}
                            >
                                <option value="" disabled selected>Select a Make</option>
                                {makes.sort((a, b) => a.localeCompare(b)).map(makeOption => (
                                    <option key={makeOption} value={makeOption}>
                                        {makeOption}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {/* Thermostat Model Dropdown */}
                    {thermostatMake && (
                        <div className="form-row">
                            <div className="form-holder">
                                <legend>Select Your Thermostat Model</legend>
                                <select
                                    name="thermostat_model"
                                    value={thermostatModel}
                                    onChange={(e) => {
                                        setThermostatModel(e.target.value);
                                        const match = filteredByMake.find(t => t.model === e.target.value);
                                        if (match) {
                                            setSelectedThermostat(match);
                                        }
                                    }}
                                >
                                    <option value="" disabled selected>Select a Model</option>
                                    {models.sort((a, b) => a.localeCompare(b)).map(modelOption => (
                                        <option key={modelOption} value={modelOption}>
                                            {modelOption}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}
                    {/* Render current thermostat devices */}
                    <div className="form-row">
                        <div className="form-holder">
                            {current_devices && current_devices.length > 0 ? (<h4>Current Thermostats</h4>) : (<div></div>)}
                            {current_devices && current_devices.length > 0 ? (
                                <div style={{
                                    padding: '10px',
                                    borderRadius: '4px',
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                    gap: '10px'
                                }}>
                                    {current_devices.sort((a, b) => a.make.localeCompare(b.make)).map((device, index) => (
                                        <div key={index} style={{
                                            backgroundColor: '#f0f0f0',
                                            border: '1px solid #ccc',
                                            padding: '10px',
                                            borderRadius: '4px'
                                        }}>
                                            {device.make} {device.model} ({device.year})
                                        </div>
                                    ))}
                                </div>
                            ) : (<div></div>)}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export const Confirmation = ({ data }) => {
    // Check if any required field is empty
    const isIncomplete =
        !data.first_name ||
        !data.last_name ||
        !data.email ||
        !data.phone_number ||
        !data.address_street ||
        !data.address_city ||
        !data.address_state ||
        !data.address_zip;

    if (isIncomplete) {
        return (
            <div>
                <section>
                    <div className="inner">
                        <div className="wizard-header">
                            <h3 className="heading">Confirmation</h3>
                            <p style={{ color: 'red' }}>Please complete your Personal Information</p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div>
            <section>
                <div className="inner">
                    <div className="wizard-header">
                        <h3 className="heading">Confirmation</h3>
                        <p>Please review your information below before proceeding.</p>
                        <p>If everything looks good, please click "Sign Up" to proceed with our external partners.</p>
                    </div>
                    <div className="form-row">
                        <div className="form-holder">
                            <h4>Personal Information</h4>
                            <p><strong>First Name:</strong> {data.first_name}</p>
                            <p><strong>Last Name:</strong> {data.last_name}</p>
                            <p><strong>Email:</strong> {data.email}</p>
                            <p><strong>Phone Number:</strong> {data.phone_number}</p>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder">
                            <h4>Address</h4>
                            <p><strong>Street:</strong> {data.address_street}</p>
                            <p><strong>City:</strong> {data.address_city}</p>
                            <p><strong>State:</strong> {data.address_state}</p>
                            <p><strong>ZIP Code:</strong> {data.address_zip}</p>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder">
                            <h4>Utility Programs</h4>
                            {data.utility_programs.length > 0 ? (
                                <div style={{
                                    backgroundColor: '#f0f0f0',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                                    gap: '10px'
                                }}>
                                    {data.utility_programs.map((program, index) => (
                                        <div key={index} style={{ padding: '5px', textAlign: 'center' }}>
                                            {program}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p>No utility programs selected.</p>
                            )}
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder">
                            <h4>Devices</h4>
                            {data.devices.length > 0 ? (
                                <div style={{
                                    padding: '10px',
                                    borderRadius: '4px',
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                    gap: '10px'
                                }}>
                                    {data.devices.map((device, index) => (
                                        <div key={index} style={{
                                            backgroundColor: '#f0f0f0',
                                            border: '1px solid #ccc', padding: '10px', borderRadius: '4px'
                                        }}>
                                            {device.make} {device.model} {device.year}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p>No devices selected.</p>
                            )}
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder">
                            <h4>Thank You</h4>
                            <p>Thank you for reviewing your information. Please proceed to the next step to complete your enrollment.</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};